"use strict";

$(document).ready(function(){
	var crmType = custom.crm;
	// mobile nav
    $('.header__nav--mobile').click(function(){
        $('.hamburger').toggleClass('is-active');
        if($('.hamburger').hasClass('is-active')){
			// $('body').css({'position' : 'fixed'});
			$('.header__nav').css({'display' : 'flex'});
			$('.header__nav--wrap').addClass('is-active');
        } else{
			// $('body').css({'position' : 'relative'});
			$('.header__nav').css({'display' : 'none'});
			$('.header__nav--wrap').removeClass('is-active');
        }
    });

	// action network
	if(crmType == 'action-network'){
		// featured
		var featured = document.querySelector('#web-featured');
		if(featured){
			$(document).on('web-featured_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
			});
		}

		// media feed cta
		var mediaCTA = document.querySelector('#web-ad');
		if(mediaCTA){
			$(document).on('web-ad_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('li.form_builder_output').remove();
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
				$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').attr('style', 'margin-bottom: 0!important');
			});
		}

		// footer cta
		var footerCTA = document.querySelector('#web-footer-cta');
		if(footerCTA){
			$(document).on('web-footer-cta_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
			});
		}
	}

	// cases and laws filter
    $('#filter').click(function(){
		if($(this).hasClass('closed')){
        	$(this).removeClass('closed').addClass('open');
			$('.entry__wrap').slideDown({
				start: function(){
					$(this).css('display', 'flex');
				}
			});
    	} else {
    		$(this).removeClass('open').addClass('closed');
			$('.entry__wrap').slideUp();
      	}
    });

	var wrap = document.querySelector('form.entry__wrap')
	if(wrap){
		wrap.addEventListener('submit', function(event){
			this.querySelectorAll('input, select').forEach(function(element){
				if(!element.value){
					element.removeAttribute('name');
				}
			});
		});
	}

	// focus areas cases/laws tab
	var focus = '/focus-areas/';
	var current = window.location.pathname;

	if(current.indexOf(focus) > -1){
		$('.entry__tabs--btn').on('click', function(){
			const targetTab = $(this).data('tab');

			$('.entry__tabs--btn').removeClass('active');
			$('.entry__tabs--panel').removeClass('active');
			
			$(this).addClass('active');
			
			$('#' + targetTab).addClass('active');
		});

		// Add smooth hover effects for cards
		$('.content-card').on('mouseenter', function(){
			$(this).css('transform', 'translateY(-2px)');
		}).on('mouseleave', function() {
			$(this).css('transform', 'translateY(0)');
		});		
	}

	// media filter
	$('[name="filter"]').change(function(){
		var url = $(this).val();
		window.location.href = url;
	});

	// contact form
	$('[name="type"]').change(function(){
		var type = $(this).val();
		if(type == 'Other'){
			$('data-name=["type-other"]').slideDown();
		} else {
			$('data-name=["type-other"]').slideUp();
		}
	});

	// assistance form
	$('[name="state"]').val('California');
	
	// lity
	$('.wp-block-image img').attr('data-lity', '');
	$('.wp-block-timeline img').attr('data-lity', '');

	// aos
	AOS.init({
		easing: 'ease',
		duration: 1500
	});

	// year
	var currentYear = new Date().getFullYear();
	$('span#year').text(currentYear);

	// anchors
	$(function(){
		$('a[href*="#"]:not([href="#"])').click(function(){
			if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname){
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length){
					$('html, body').animate({ scrollTop: target.offset().top - 100 }, 1000);
					return false;
				}
			}
		});
	});
});